module.exports = {
  email: "hi@theev.net"
};



// WEBPACK FOOTER //
// ./data/contact.js